import React from 'react'
import { Box } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { Tabs } from '../../../layout/MainLayout'
import UserProfile from '../components/UserProfile'

interface ProfileAppProps {
  tab: Tabs
}

const ProfileApp: React.FC<ProfileAppProps> = ({ tab }) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: theme.palette.background.custom1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <UserProfile />
    </Box>
  )
}

export default ProfileApp
